import { pathOr } from 'ramda';
import {
  FETCH_BONUSES_CONTENT_REQUEST,
  FETCH_BONUSES_CONTENT_FAIL,
  FETCH_BONUSES_CONTENT_SUCCESS,
} from '../../../constants/bonuses';

export const initialState = {
  isLoading: false,
  isLoaded: false,
};

function bonusContent(state = initialState, { type }) {
  switch (type) {
    case FETCH_BONUSES_CONTENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };

    case FETCH_BONUSES_CONTENT_FAIL:
    case FETCH_BONUSES_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
      };

    default:
      return state;
  }
}

export default bonusContent;

// SELECTORS

export const getIsBonusesContentLoadingSelector = (state) =>
  pathOr(initialState.isLoading, ['app', 'bonusContent', 'isLoading'], state);
export const getIsBonusesContentLoadedSelector = (state) =>
  pathOr(initialState.isLoaded, ['app', 'bonusContent', 'isLoaded'], state);
